import theme from 'theme'

export const DEFAULT_MENU_PROPS = {
  PaperProps: {
    sx: {
      backgroundColor: theme.colors.borderMedium,
      transform: `translateY(${theme.spacing.xSmall}px) !important`,
      "html[data-theme='light'] &": {
        backgroundColor: theme.colors.surfaceContainerBackground
      },
      '& ul': {
        paddingTop: 0,
        paddingBottom: 0
      },
      /* Radio rows and the footer action, used by single-select lists. */
      '& .MuiMenuItem-root.radio-option': {
        gap: `${theme.spacing.xSmall}px`,
        justifyContent: 'flex-start',
        padding: `${theme.spacing.sm}px ${theme.spacing.small}px`,
        color: theme.colors.devicesSecondaryText,
        fontSize: theme.typography.fontSize.large,
        fontWeight: theme.typography.fontWeight.bold,
        lineHeight: '22px'
      },
      '& .MuiMenuItem-root.radio-option.selected': {
        color: theme.colors.menuItemText
      },
      '& .MuiListSubheader-root.list-action': {
        display: 'flex',
        alignItems: 'center',
        height: '48px',
        padding: `0 ${theme.spacing.medium}px`,
        color: theme.colors.cta,
        fontFamily: theme.typography.fontFamily.primary,
        fontSize: theme.typography.fontSize.large,
        fontWeight: theme.typography.fontWeight.bold,
        lineHeight: '22px',
        cursor: 'pointer'
      }
    },
    style: {
      width: 300,
      maxHeight: 200,
      borderRadius: theme.spacing.md
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
